(function () {
  var VISIBLE = 3; // cards shown before "view all" on mobile

  function init(section) {
    var grid = section.querySelector('.categories-custom__grid');
    var button = section.querySelector('[data-categories-toggle]');
    if (!grid || !button) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.category-card'));
    var extras = cards.slice(VISIBLE);
    if (extras.length === 0) {
      button.style.display = 'none';
      return;
    }

    var mq = window.matchMedia('(max-width: 767px)');
    var expanded = false;
    var animating = false;

    function clearExtraStyles() {
      extras.forEach(function (c) {
        c.style.display = '';
        c.style.opacity = '';
        c.style.transform = '';
      });
    }

    function showAllInstant() {
      clearExtraStyles();
      grid.style.height = '';
      grid.style.overflow = '';
    }

    function collapseInstant() {
      extras.forEach(function (c) {
        c.style.display = 'none';
      });
      grid.style.height = '';
      grid.style.overflow = '';
      button.textContent = button.dataset.more;
    }

    function expand() {
      if (animating) return;
      expanded = true;
      button.textContent = button.dataset.less;

      var startH = grid.offsetHeight;
      extras.forEach(function (c) {
        c.style.display = 'flex';
        c.classList.add('is-in'); // ensure scroll-anim hidden state is revealed
      });
      var endH = grid.offsetHeight;

      if (!window.gsap) {
        grid.style.height = '';
        return;
      }

      animating = true;
      grid.style.overflow = 'hidden';
      window.gsap.fromTo(
        grid,
        { height: startH },
        {
          height: endH,
          duration: 0.5,
          ease: 'power2.out',
          onComplete: function () {
            grid.style.height = '';
            grid.style.overflow = '';
            animating = false;
          },
        }
      );
    }

    function collapse() {
      if (animating) return;
      expanded = false;
      button.textContent = button.dataset.more;

      var startH = grid.offsetHeight;
      extras.forEach(function (c) {
        c.style.display = 'none';
      });
      var endH = grid.offsetHeight;
      extras.forEach(function (c) {
        c.style.display = 'flex';
      });

      if (!window.gsap) {
        extras.forEach(function (c) {
          c.style.display = 'none';
        });
        return;
      }

      animating = true;
      grid.style.overflow = 'hidden';
      window.gsap.fromTo(
        grid,
        { height: startH },
        {
          height: endH,
          duration: 0.45,
          ease: 'power2.inOut',
          onComplete: function () {
            extras.forEach(function (c) {
              c.style.display = 'none';
            });
            grid.style.height = '';
            grid.style.overflow = '';
            animating = false;
            // keep the page anchored near the button
            button.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          },
        }
      );
    }

    function toggle() {
      if (expanded) collapse();
      else expand();
    }

    function apply() {
      window.gsap && window.gsap.killTweensOf([grid].concat(extras));
      animating = false;
      if (mq.matches) {
        button.style.display = 'flex';
        if (expanded) showAllInstant();
        else collapseInstant();
      } else {
        // tablet / desktop: everything visible, no button
        button.style.display = 'none';
        showAllInstant();
      }
    }

    button.addEventListener('click', toggle);
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);

    apply();
  }

  function initAll() {
    document.querySelectorAll('.categories-custom').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when added/edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.categories-custom');
    if (section) init(section);
  });
})();
